import type { SponsorPlanItem } from '@app/_proto/Protos/sponsors';
import type { SubscriptionItem } from '@app/_proto/Protos/subscriptions';
import { ChampionPlanWithPriceButton } from '@app/domains/champion/components/ChampionPlanButtonOnly';
import ChampionPlanWithDialog from '@app/domains/champion/containers/ChampionPlanWithDialog';
import { useState } from 'react';

type ChampionCallToActionProps = {
    currentSubscription: SubscriptionItem | null;
    sortedSponsorPlans: SponsorPlanItem[];
    onSelectPlan?: (plan: SponsorPlanItem) => void;
};

export default function ChampionCallToAction({
    currentSubscription,
    sortedSponsorPlans,
    onSelectPlan,
}: ChampionCallToActionProps) {
    const [isSubscribed, setIsSubscribed] = useState(false);

    const handlePlanSubscribed = (plan: SponsorPlanItem) => {
        setIsSubscribed(true);
        onSelectPlan?.(plan);
    };

    const plan = sortedSponsorPlans.length > 0 ? sortedSponsorPlans[0] : null;

    if (!plan || isSubscribed) {
        return null;
    }

    return (
        <div className="flex flex-col md:flex-row items-center justify-center mt-42 w-full mx-auto gap-24 bg-white dark:bg-black shadow p-24 rounded-10">
            <div className="flex-1 max-w-[770px]">
                <div className="font-bold text-[28px] leading-tight text-center md:text-left mb-16">
                    <div className="text-black dark:text-white">Subscribe to read</div>
                    <div className="text-blue-600">all chapters</div>
                </div>
                <div className="text-gray-750 dark:text-gray-400 leading-tight text-[15.2px] text-center sm:text-left">
                    Directly support authors and translators and be rewarded for it!
                </div>
            </div>
            <div className="flex-1 text-end w-full max-w-355 md:w-auto">
                <ChampionPlanWithDialog
                    plan={plan}
                    currentSubscription={currentSubscription}
                    onSelectPlan={handlePlanSubscribed}
                    renderChampionPlan={ChampionPlanWithPriceButton}
                />
            </div>
        </div>
    );
}
